import React, { Component } from 'react'
import { get } from 'lodash/object'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { CUSTOMER_API } from 'constants/ResourcesConstants'
import { Button, Input } from '@driftt/tide-core-legacy'
import greenCheckCircleIconSrc from 'images/svg/green-check-circle.svg'
import stripeSrc from 'images/logos/stripe.png'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as IntegrationsActions from 'app/modules/integrations/actions'
import * as IntegrationsSelectors from 'app/modules/integrations/selectors'



const STRIPE_SETTINGS_ID_SAVE = 'stripe-integration-settings-save'

class Stripe extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editingPublicKey: get(props, 'stripeKeys.publicKey'),
      editingPrivateKey: get(props, 'stripeKeys.privateKey'),
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stripeKeys !== this.props.stripeKeys) {
      this.setState({
        editingPrivateKey: get(this.props, 'stripeKeys.privateKey'),
        editingPublicKey: get(this.props, 'stripeKeys.publicKey'),
      })
    }
  }

  componentDidMount() {
    if (this.props.stripeKeysNeverFetched) {
      this.props.actions.fetchStripeKeys()
    }
  }

  isEditedKeyDirty = () => {
    return this.state.editingPublicKey !== get(this.props, 'stripeKeys.publicKey') ||
      this.state.editingPrivateKey !== get(this.props, 'stripeKeys.privateKey')
  }

  onChangePrivateKey = (e) => {
    this.setState({
      editingPrivateKey: e.target.value,
    })
  }

  onChangePublicKey = (e) => {
    this.setState({
      editingPublicKey: e.target.value,
    })
  }


  onSaveStripeSettings = () => {
    this.props.actions.asyncButtonPress({
      url: `${CUSTOMER_API}/integrations/stripe/keys`,
      method: 'patch',
      data: {
        enabled: true,
        publicKey: this.state.editingPublicKey,
        privateKey: this.state.editingPrivateKey,
      },
      successMessage: `Successfully saved your Stripe settings!`,
      errorMessage: `Something went wrong and we couldn’t save your Stripe settings`,
      clickId: STRIPE_SETTINGS_ID_SAVE,
      successCallback: this.onSuccessfulSave,
    })
  }

  onDisconnectStripe = () => {
    this.props.actions.asyncButtonPress({
      url: `${CUSTOMER_API}/integrations/stripe/keys`,
      method: 'patch',
      data: {
        enabled: false,
        publicKey: '',
        privateKey: '',
      },
      successMessage: 'Successfully disconnected your Stripe account!',
      errorMessage: `Something went wrong and we couldn’t disconnect your Stripe account`,
      clickId: STRIPE_SETTINGS_ID_SAVE,
    })
  }


  render() {
    const {
      editingPrivateKey,
      editingPublicKey,
    } = this.state

    const {
      saveStripeSettingsPending,
      stripeKeys,
    } = this.props

    return (
      <div>
        <div className="integration-facebook-title-container">
          <img className="integration-facebook-title-image" src={stripeSrc} />
          <span>{stripeKeys && stripeKeys.publicKey && <span className="integration-facebook-title-connected"><img src={greenCheckCircleIconSrc} />Connected</span>}</span>
        </div>
        <p>Process payments in Drift conversations with Stripe.</p>
        <div className="connect-container">
          <Input type="text" disabled={saveStripeSettingsPending} value={editingPublicKey} onChange={this.onChangePublicKey} placeholder="Your Stripe public key" label="Stripe Public Key" className="integration-facebook-pixel-id-input"/>
          <Input type="text" disabled={saveStripeSettingsPending} value={editingPrivateKey} onChange={this.onChangePrivateKey} placeholder="Your Stripe private key" label="Stripe Private Key" className="integration-facebook-pixel-id-input"/>
          <Button disabled={!this.isEditedKeyDirty() || saveStripeSettingsPending} className="integration-facebook-pixel-save-button" onClick={this.onSaveStripeSettings}>Connect</Button>
          {stripeKeys && stripeKeys.publicKey && <Button disabled={saveStripeSettingsPending} onClick={this.onDisconnectStripe} type="secondary">Disconnect</Button>}
        </div>
      </div>
    )

  }
}


const mapStateToProps = (state) => {
  return {
    saveStripeSettingsPending: PlaybookSelectors.asyncButtonPending(state, STRIPE_SETTINGS_ID_SAVE),
    stripeKeysNeverFetched: IntegrationsSelectors.stripeKeysNeverFetched(state),
    fetchStripeKeysPending: IntegrationsSelectors.isStripeKeysPending(state),
    stripeKeys: IntegrationsSelectors.stripeKeysData(state),
  }
}



const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      asyncButtonPress: PlaybookActions.asyncButtonPress,
      fetchStripeKeys: IntegrationsActions.fetchStripeKeys,
    },
    dispatch
  ),
})


export default connect(mapStateToProps, mapDispatchToProps)(Stripe)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Stripe.js